export const URL_NOTIFY_APPOINTMENT = "/v1/gocheckin/notification/site/list-appointment?"
export const URL_NOTIFY_SYSTEM = "/v1/gocheckin/notification/site/list?"
export const URL_MARK_AS_READ = '/v1/gocheckin/notification/form/mark-is-read'
